export const ID_EXIST_MESSAGE = 'ID already exists';
export const HAS_RELATED_DATA = "has related data, can't support delete";
export const FORBIDDEN_RESOURCE = 'Forbidden resource';
